import React, { useState, useEffect, useContext } from "react";

import * as Yup from "yup";
import {Formik, Form, Field, FieldArray} from "formik";
import { toast } from "react-toastify";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	CircularProgress,
	Select,
	InputLabel,
	MenuItem,
	FormControl,
	TextField,
	Tooltip,
	Avatar,
} from '@material-ui/core';


import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import QueueSelect from "../QueueSelect";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../Can";
import useWhatsApps from "../../hooks/useWhatsApps";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import ChangePasswordModal from "../ChangePasswordModal";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import ReplayIcon from '@material-ui/icons/Replay';
import { PhotoCamera, Visibility, VisibilityOff } from "@material-ui/icons";
import CryptoJS from "crypto-js";
import ConfirmationModal from "../ConfirmationModal";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	multFieldLine: {
		display: "flex",
		"& > *:not(:last-child)": {
			marginRight: theme.spacing(1),
		},
	},

	multFieldLineCenter: {
		display: "flex",
		justifyContent: "center", // Centraliza horizontalmente
		alignItems: "center", // Centraliza verticalmente
		"& > *:not(:last-child)": {
			marginRight: theme.spacing(1),
		},
		height: "100%", // Opcional: garante que a div tenha altura suficiente para centralização vertical
		marginBottom: theme.spacing(1),
	},

	btnWrapper: {
		position: "relative",
	},

	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	timeField: {
		marginRight: theme.spacing(1),
		width: 150,
		fontSize: "12pt"
	},
	smallMagin: {
		margin: theme.spacing(1),
		width: "40%",
	},
	xsMargin: {
		margin: theme.spacing(1),
		width: "15%",
	},
	avatarContainer: {
		position: "relative",
		display: "inline-block",
		cursor: "pointer",
	},
	redirectAttr: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginBottom: theme.spacing(1),
	},
	extraAttr: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	textField: {
		marginRight: theme.spacing(1),
		flex: 1,
	},
	avatar: {
		width: 150,
		height: 150,
	},
	overlay: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escurecido
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		color: "#fff",
		borderRadius: "50%",
		opacity: 0,
		transition: "opacity 0.3s ease-in-out",
	},
	icon: {
		fontSize: 24,
		marginBottom: 5,
	},
	overlayVisible: {
		opacity: 1,
	},
}));

const UserSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, "Too Short!")
		.max(50, "Too Long!")
		.required("Required"),
	password: Yup.string().min(5, "Too Short!").max(50, "Too Long!"),
	email: Yup.string().email("Invalid email").required("Required"),
});

const UserModal = ({ open, onClose, userId }) => {
	const classes = useStyles();

	const initialState = {
		name: "",
		email: "",
		password: "",
		profile: "user"
	};

	const { user: loggedInUser } = useContext(AuthContext);

	const [user, setUser] = useState(initialState);
	const [selectedQueueIds, setSelectedQueueIds] = useState([]);
	const [showPassword, setShowPassword] = useState(false);
	const [whatsappId, setWhatsappId] = useState(false);
	const { loading, whatsApps } = useWhatsApps();

	const [weekdays, setWeekdays] = useState(true);
	const [sss, setSss] = useState(false);
	const [suu, setSuu] = useState(false);
	const [hhh, setHhh] = useState(false);
	const [startTime, setStartTime] = useState("08:00");
	const [endTime, setEndTime] = useState("18:00");
	const [active, setActive] = useState(true);

	const [editContact, setEditContact] = useState(true);
	const [addContact, setAddContact] = useState(true);
	const [delContact, setDelContact] = useState(true);

	const [restrictConnection, setRestrictConnection] = useState(false);

	const [changePasswordModal, setChangePasswordModal] = useState(false);
	const [confirmOpen, setConfirmOpen] = useState(false);

	const [hover, setHover] = useState(false);
	const [queueOptions, setQueueOptions] = useState([]);
	const [userOptions, setUserOptions] = useState([]);

	useEffect(() => {
		const fetchUser = async () => {
			if (!userId) return;
			try {
				const { data } = await api.get(`/users/${userId}`);

				if (data.substitution?.length > 0) {
					for (let i = 0; i < data.substitution.length; i++) {
						const substitution = data.substitution[i];
						data.substitution[i] = {
							...data.substitution[i],
							name: substitution.queueId,
							value: substitution.substituteId,
						}
					}
				}

				const decryptedEmail = !isEmail(data.email) ? decrypt(data.email) : data.email;
				setUser(prevState => {
					return { ...prevState, ...data, email: decryptedEmail };
				});

				const userQueueIds = data.queues?.map(queue => queue.id);
				setSelectedQueueIds(userQueueIds);
				setWhatsappId(data.whatsappId ? data.whatsappId : '');
				setWeekdays(data.weekdays);
				setSss(data.saturday);
				setSuu(data.sunday);
				setHhh(data.holidays);
				setStartTime(data.startTime);
				setEndTime(data.endTime);
				setAddContact(data.addContact);
				setEditContact(data.editContact);
				setDelContact(data.delContact);
				setRestrictConnection(data.restrictConnection);
				setActive(data.active);
			} catch (err) {
				toastError(err);
			}
		};

		fetchUser();
	}, [userId, open]);

	useEffect(() => {
		const fetchQueueUser = async () => {
			try {
				const { data: queues } = await api.get(`/queue`);
				setQueueOptions(queues);

				const { data: users } = await api.get(`/users`, {
                    params: { all: true, userId: user?.id },
                });
				setUserOptions(users?.users);
			} catch (err) {
				toastError(err);
			}
		};

		fetchQueueUser();
	}, [open, user]);

	const handleChangeWeekdays = async (event) => {
		const { name, checked } = event.target;

		try {
			if (name === "weekdays")
				setWeekdays(checked)
			if (name === "saturday")
				setSss(checked)
			if (name === "sunday")
				setSuu(checked)
			if (name === "holidays")
				setHhh(checked)
		} catch (err) {
			toastError(err);
		}
	};

	const handleChangeContact = (event) => {
		const { name, checked } = event.target;
		if (name === "editContact")
			setEditContact(checked)
		if (name === "addContact")
			setAddContact(checked)
		if (name === "delContact")
			setDelContact(checked)
	};

	const handleChangeRestrict = (event) => {
		const { checked } = event.target;
		setRestrictConnection(checked);
	}

	const handleClose = () => {
		onClose();
		setWeekdays(true);
		setSss(false);
		setSuu(false);
		setHhh(false);
		setStartTime("08:00");
		setEndTime("18:00");
		setUser(initialState);
	};

	function isStrongPassword(password) {
		const minLength = 8;
		const hasUpperCase = /[A-Z]/.test(password);
		const hasLowerCase = /[a-z]/.test(password);
		const hasNumber = /\d/.test(password);
		const hasSpecialChar = /[\W_]/.test(password);

		return (
			password.length >= minLength &&
			hasUpperCase &&
			hasLowerCase &&
			hasNumber &&
			hasSpecialChar
		);
	}

	function validatePassword(password) {
		if (password.length < 8) return "A senha deve ter no mínimo 8 caracteres.";
		if (!/[A-Z]/.test(password)) return "A senha deve ter pelo menos uma letra maiúscula.";
		if (!/[a-z]/.test(password)) return "A senha deve ter pelo menos uma letra minúscula.";
		if (!/\d/.test(password)) return "A senha deve ter pelo menos um número.";
		if (!/[\W_]/.test(password)) return "A senha deve ter pelo menos um caractere especial.";
	}

	const encryptData = (data) => {
		const secretKey = window.env?.REACT_APP_SECRET_KEY || process.env.REACT_APP_SECRET_KEY;
		return CryptoJS.AES.encrypt(data, secretKey).toString();
	}

	function decrypt(encryptedData) {
		const secretKey = window.env?.REACT_APP_SECRET_KEY || process.env.REACT_APP_SECRET_KEY;
		const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
		return bytes.toString(CryptoJS.enc.Utf8);
	}

	const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

	const hasDuplicateNames = (arr) => {
		const nameSet = new Set();
		for (const item of arr) {
			if (nameSet.has(item.name)) {
				return true; // Encontrou um name repetido
			}
			nameSet.add(item.name);
		}
		return false; // Não há duplicatas
	};

	const hasEmptyFields = (arr) => {
		return arr.some(item =>
			item.name === undefined || item.name === null || item.name === "" ||
			item.value === undefined || item.value === null || item.value === ""
		);
	};

	const userBelongsQueue = (arr) => {
		for (const item of arr) {
			const checkUser = userOptions.find(usr => usr.id === item.value);
			if (checkUser) {
				const checkQueue = checkUser.queues?.some(queue => queue.id === item.name);
				if (!checkQueue) {
					toast.error(`O(a) usuário(a) ${checkUser.name} não pertence à essa fila`);
					return false;
				}
			}
		}
		return true;
	}

	const handleSaveUser = async values => {
		if (values.password) {
			if (!isStrongPassword(values.password)) {
				toast.warn(validatePassword(values.password));
				return;
			}
		}

		if (restrictConnection && !whatsappId) {
			toast.error("Para restringir a conexão você deve selecionar uma conexão padrão");
			return;
		}

		const userData = {
			...values,
			email: encryptData(values.email),
			whatsappId,
			queueIds: selectedQueueIds,
			weekdays,
			saturday: sss,
			sunday: suu,
			holidays: hhh,
			startTime,
			endTime,
			editContact,
			addContact,
			delContact,
			restrictConnection,
			active: active ?? undefined,
			log: JSON.stringify({
				userId: loggedInUser?.id,
				userName: loggedInUser?.name
			})
		};

		if (values.substitution?.length > 0 && hasDuplicateNames(values.substitution)) {
			toast.error("Não deve haver mais de uma substituição para a mesma fila");
			return;
		}

		if (values.substitution?.length > 0 && hasEmptyFields(values.substitution)) {
			toast.error("Não deve existir substituições sem fila/usuário atribuído");
			return;
		}

		if (values.substitution?.length > 0 && !userBelongsQueue(values.substitution)) return;

		try {
			if (userId) {
				await api.put(`/users/${userId}`, userData);

                if (values.substitution?.length > 0) {
                    const transfers = values.substitution.filter(sub => sub.transfer);

                    if (transfers.length > 0) {
                        for (const item of transfers) {
                            await api.post(`/users/transfer/${userId}`, {
                                substituteId: item.value,
                                queueId: item.name
                            });
                        }
                    }
                }
			} else {
				await api.post("/users", userData);
			}
			toast.success(i18n.t("userModal.success"));
		} catch (err) {
			toastError(err);
		}
		handleClose();
	};

	const handleChangePass = async (e) => {
		setChangePasswordModal(true);
	}

	const handleCloseChangePass = async (e) => {
		setChangePasswordModal(false);
	}

	const handleResetPass = async (e) => {
		try {
			const criptedPass = encryptData("123456");

			await api.post(`/users/reset/${userId}`, {
				password: criptedPass,
				log: JSON.stringify({
					userId: loggedInUser?.id,
					userName: loggedInUser?.name
				})
			});
			toast.success("Senha alterada com sucesso!");
			handleClose();
		} catch (e) {
			toastError(e);
		}
	}

	const handleChangePicture = async () => {
		const fileInput = document.createElement("input");
		fileInput.type = "file";
		fileInput.accept = "image/*"; // Aceita apenas arquivos de imagem
		fileInput.onchange = async (event) => {
			const file = event.target.files[0];
			if (file) {
				const formData = new FormData();
				formData.append("medias", file);
				formData.append("log", JSON.stringify({
					userId: loggedInUser?.id,
					userName: loggedInUser?.name
				}));

				try {
					const { data } = await api.post(`/users/picture/${userId}`, formData, {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					});

					// Atualiza a URL da foto de perfil no estado do usuário
					setUser((prevUser) => ({
						...prevUser,
						profilePicUrl: data.profilePicUrl,
					}));

					toast.success("Foto de perfil atualizada com sucesso!");
					handleClose();
				} catch (err) {
					toastError(err);
				}
			}
		};

		fileInput.click(); // Simula o clique no input para abrir o seletor de arquivos
	}

	return (
		<div className={classes.root}>
			<Dialog
				open={open}
				onClose={handleClose}
				maxWidth="sm"
				fullWidth
				scroll="paper"
			>
				<DialogTitle id="form-dialog-title">
					{userId
						? `${i18n.t("userModal.title.edit")}`
						: `${i18n.t("userModal.title.add")}`}
				</DialogTitle>
				<Formik
					initialValues={user}
					enableReinitialize={true}
					validationSchema={UserSchema}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							handleSaveUser(values);
							actions.setSubmitting(false);
						}, 400);
					}}
				>
					{({ touched, errors, isSubmitting, values }) => (
						<Form>
							<ChangePasswordModal
								open={changePasswordModal}
								onClose={handleCloseChangePass}
								userId={userId}
								queueIds={selectedQueueIds}
							></ChangePasswordModal>
							<ConfirmationModal
								title="Resetar senha"
								open={confirmOpen}
								onClose={setConfirmOpen}
								onConfirm={handleResetPass}
							>
								Deseja redefinir a senha desse usuário para a senha padrão ("123456")? Essa ação não poderá ser revertida
							</ConfirmationModal>
							<DialogContent dividers>
								<div className={classes.multFieldLineCenter}>
									<div
										className={classes.avatarContainer}
										onMouseEnter={() => setHover(true)}
										onMouseLeave={() => setHover(false)}
										onClick={() => handleChangePicture()}
									>
										<Avatar alt="Profile Picture" src={values.profilePicUrl} className={classes.avatar} />
										<div className={`${classes.overlay} ${hover ? classes.overlayVisible : ""}`}>
											<PhotoCamera className={classes.icon} />
											<span>Mudar foto do perfil</span>
										</div>
									</div>
								</div>
								<div className={classes.multFieldLine}>
									<Field
										as={TextField}
										label={i18n.t("userModal.form.name")}
										autoFocus
										name="name"
										error={touched.name && Boolean(errors.name)}
										helperText={touched.name && errors.name}
										variant="outlined"
										margin="dense"
										fullWidth
									/>

									{userId && (
										<Button
											size="small"
											className={classes.smallMagin}
											color="primary"
											variant="outlined"
											onClick={handleChangePass}
										>
											Alterar senha
										</Button>
									)}

									{userId && (
										<Tooltip
											arrow
											title={"Redefinir senha"}
											placement="top"
										>
											<Button
												size="small"
												className={classes.xsMargin}
												color="primary"
												variant="outlined"
												onClick={() => setConfirmOpen(true)}
											>
												<ReplayIcon />
											</Button>
										</Tooltip>
									)}

									{!userId && (
										<Field
											as={TextField}
											name="password"
											variant="outlined"
											margin="dense"
											label={i18n.t("userModal.form.password")}
											error={touched.password && Boolean(errors.password)}
											helperText={touched.password && errors.password}
											type={showPassword ? 'text' : 'password'}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={() => setShowPassword((e) => !e)}
														>
															{showPassword ? <VisibilityOff /> : <Visibility />}
														</IconButton>
													</InputAdornment>
												)
											}}
											fullWidth
										/>
									)}
								</div>
								<div className={classes.multFieldLine}>
									<Field
										as={TextField}
										label={i18n.t("userModal.form.email")}
										name="email"
										error={touched.email && Boolean(errors.email)}
										helperText={touched.email && errors.email}
										variant="outlined"
										margin="dense"
										fullWidth
									/>
									<FormControl
										variant="outlined"
										className={classes.formControl}
										margin="dense"
									>
										<Can
											role={loggedInUser.profile}
											perform="user-modal:editProfile"
											yes={() => (
												<>
													<InputLabel id="profile-selection-input-label">
														{i18n.t("userModal.form.profile")}
													</InputLabel>

													<Field
														as={Select}
														label={i18n.t("userModal.form.profile")}
														name="profile"
														labelId="profile-selection-label"
														id="profile-selection"
														required
													>
														<MenuItem value="admin">Administrador</MenuItem>
														<MenuItem value="gerente">Gerente</MenuItem>
														<MenuItem value="user">Usuário</MenuItem>
													</Field>
												</>
											)}
										/>
									</FormControl>
								</div>
								<Can
									role={loggedInUser.profile}
									perform="user-modal:editQueues"
									yes={() => (
										<QueueSelect
											selectedQueueIds={selectedQueueIds}
											onChange={values => setSelectedQueueIds(values)}
										/>
									)}
								/>
								<Can
									role={loggedInUser.profile}
									perform="user-modal:editQueues"
									yes={() => (!loading &&
										<>
											<FormControl variant="outlined" margin="dense" className={classes.maxWidth} fullWidth>
												<InputLabel>{i18n.t("userModal.form.whatsapp")}</InputLabel>
												<Field
													as={Select}
													value={whatsappId}
													onChange={(e) => setWhatsappId(e.target.value)}
													label={i18n.t("userModal.form.whatsapp")}
												>
													<MenuItem value={''}>&nbsp;</MenuItem>
													{whatsApps.map((whatsapp) => (
														<MenuItem key={whatsapp.id} value={whatsapp.id}>{whatsapp.name}</MenuItem>
													))}
												</Field>
											</FormControl>

											<FormGroup row>
												<Tooltip arrow placement="top" title="Essa opção permite com que o usuário crie atendimentos apenas para a conexão padrão">
													<FormControlLabel
														control={<Checkbox checked={restrictConnection} onChange={handleChangeRestrict} name="restrictConnection"/>}
														label="Restringir conexão"
													/>
												</Tooltip>
											</FormGroup>
										</>
									)}
								/>
								<hr/>
								<Can
									role={loggedInUser.profile}
									perform="user-modal:editQueues"
									yes={() => (!loading &&
										<>
											<FormControlLabel
												control={<Checkbox checked={active} onChange={(e) => setActive((prevState) => !prevState)} name="active" />}
												label="Ativo"
											/>
											<FieldArray name="substitution">
												{({ push, remove }) => (
													<>
														{values.substitution &&
															values.substitution.length > 0 &&
															values.substitution.map((info, index) => (
																<div
																	className={classes.redirectAttr}
																	key={`${index}-substitution`}
																>
																	<Field
																		as={Select}
																		label="Fila"
																		placeholder="Fila"
																		name={`substitution[${index}].name`}
																		variant="outlined"
																		margin="dense"
																		displayEmpty
																		className={classes.textField}
																	>
																		<MenuItem value="" disabled>
																			<span style={{ color: "#aaa" }}>Fila</span>
																		</MenuItem>
																		{ queueOptions.length > 0 && queueOptions.map((queue) => (
																			<MenuItem key={`queueOption-` + queue.id} value={queue.id}>{queue.name}</MenuItem>
																		))}
																	</Field>

																	<Field
																		as={Select}
																		label="Usuário"
																		placeholder="Usuário"
																		name={`substitution[${index}].value`}
																		variant="outlined"
																		margin="dense"
																		displayEmpty
																		className={classes.textField}
																	>
																		<MenuItem value="" disabled>
																			<span style={{ color: "#aaa" }}>Usuário</span>
																		</MenuItem>
																		{ userOptions.length > 0 && userOptions.map((usr) => (
																			<MenuItem key={`userOption-` + usr.id} disabled={userId === usr.id} value={usr.id}>{usr.name}</MenuItem>
																		))}
																	</Field>

																	<Field name={`substitution[${index}].transfer`}>
																		{({ field }) => (
																			<FormControlLabel
																				control={<Checkbox {...field} checked={field.value} />}
																				label="Transferir atendimentos"
																			/>
																		)}
																	</Field>


																	<IconButton
																		size="small"
																		onClick={() => remove(index)}
																	>
																		<DeleteOutlineIcon />
																	</IconButton>
																</div>
															))}
														<div className={classes.extraAttr}>
															<Button
																style={{ flex: 1, marginTop: 8 }}
																variant="outlined"
																color="primary"
																disabled={active}
																onClick={() => push({ name: "", value: "", transfer: false })}
															>
																+ Adicionar substituições
															</Button>
														</div>
													</>
												)}
											</FieldArray>
										</>
									)}
								/>
								<br />
								<hr/>
								<Can
									role={loggedInUser.profile}
									perform="user-modal:editQueues"
									yes={() => (!loading &&
										<>
											<FormGroup row>
												<FormControlLabel
													control={<Checkbox checked={addContact} onChange={handleChangeContact} name="addContact" />}
													label="Adicionar Contato"
												/>
												<Tooltip arrow placement="top" title="Bloqueia/libera edição, delegação, importação e exportação de contato">
													<FormControlLabel
														control={<Checkbox checked={editContact} onChange={handleChangeContact} name="editContact"/>}
														label="Editar Contato"
													/>
												</Tooltip>
												<FormControlLabel
													control={<Checkbox checked={delContact} onChange={handleChangeContact} name="delContact" />}
													label="Excluir Contato"
												/>
											</FormGroup>

											<FormGroup row>
												<FormControlLabel
													control={<Checkbox checked={weekdays} onChange={handleChangeWeekdays} name="weekdays" />}
													label="Segunda à Sexta"
												/>
												<FormControlLabel
													control={<Checkbox checked={sss} onChange={handleChangeWeekdays} name="saturday" />}
													label="Sábado"
												/>
												<FormControlLabel
													control={<Checkbox checked={suu} onChange={handleChangeWeekdays} name="sunday" />}
													label="Domingo"
												/>
												<FormControlLabel
													control={<Checkbox checked={hhh} onChange={handleChangeWeekdays} name="holidays" />}
													label="Feriados"
												/>
											</FormGroup>
											<br />
											<TextField
												label="Início expediente"
												name="startTime"
												type="time"
												value={startTime}
												onChange={(e) => setStartTime(e.target.value)}
												// defaultValue="08:00"
												className={classes.timeField}
												InputLabelProps={{
													shrink: true,
												}}
												inputProps={{
													step: 300, // 5 min
												}}
											/>
											<TextField
												label="Fim expediente"
												name="endTime"
												type="time"
												value={endTime}
												onChange={(e) => setEndTime(e.target.value)}
												// defaultValue="18:00"
												className={classes.timeField}
												InputLabelProps={{
													shrink: true,
												}}
												inputProps={{
													step: 300, // 5 min
												}}
											/>
										</>
									)}
								/>
							</DialogContent>
							<DialogActions>
								<Button
									onClick={handleClose}
									color="secondary"
									disabled={isSubmitting}
									variant="outlined"
								>
									{i18n.t("userModal.buttons.cancel")}
								</Button>
								<Button
									type="submit"
									color="primary"
									disabled={isSubmitting}
									variant="contained"
									className={classes.btnWrapper}
								>
									{userId
										? `${i18n.t("userModal.buttons.okEdit")}`
										: `${i18n.t("userModal.buttons.okAdd")}`}
									{isSubmitting && (
										<CircularProgress
											size={24}
											className={classes.buttonProgress}
										/>
									)}
								</Button>
							</DialogActions>
						</Form>
					)}
				</Formik>
			</Dialog>
		</div>
	);
};

export default UserModal;